import "./frontend.scss"
import React from "react";
import ReactDOM from "react-dom";

// Define the function that renders the React component
function renderPMFeed(divsToUpdate) {

  // Define the PMFeed component
  function PMFeed(props) {
    return (
      <div className="lmb-publications-link-frontend">
        <div className="lmb-publications-link et-social-icon">
          <a href={props.publicationsLink} target="_blank" rel="noopener" title="Academia">
            {/* Conditionally render an icon based on the value of props.linkIcon */}
            {props.linkIcon === "orcid" ? (
              <i className="ai ai-orcid ai-3x"></i>
            ) : props.linkIcon === "pubmed" ? (
              <i className="ai ai-pubmed ai-3x"></i>
            ) : props.linkIcon === "gscholar" ? (
              <i className="ai ai-google-scholar ai-3x"></i>
            ) : props.linkIcon === "twitter-white" ? (
                <i className="dashicons dashicons-twitter dashicons-twitter-white"></i>
            ) : props.linkIcon === "twitter" ? (
              <i className="dashicons dashicons-twitter"></i>
            ) : props.linkIcon === "linkedin" ? (
              <i className="dashicons dashicons-linkedin"></i>
            ) : props.linkIcon === "youtube" ? (
              <i className="dashicons dashicons-youtube"></i>
            ) : null}
          </a>
        </div>
      </div>
    );
  }

  // Loop over each element with class "lmb-publication-list-icons-update-me",
  // parse the data from the <pre> tag, and render the React component
  divsToUpdate.forEach((div) => {
    const data = JSON.parse(div.querySelector("pre").innerHTML);
    ReactDOM.render(<PMFeed {...data} />, div, () => {
      // Remove the "lmb-publication-list-icons-update-me" class when the component is mounted
      div.classList.remove("lmb-publication-list-icons-update-me");
    });
  });
}

// Select all elements with class "lmb-publication-list-icons-update-me"
const divsToUpdate = document.querySelectorAll(".lmb-publication-list-icons-update-me");

// Call the renderPMFeed function with the selected elements
renderPMFeed(divsToUpdate);